<template>
  <div id="event-summary">
    <div id="monitoring-vessel-engine-header">
      <div id="header-text" class="sdf-text-22-700-white">
        イベントサマリー
      </div>
      <div class="vessel-communication-channel-area">
        <vessel-communication-channel />
      </div>
    </div>
    <input-display-condition
      ref="engineDisplayCondition"
      :showDataCategory="false"
    ></input-display-condition>
    <div id="event-data-details">
      <div id="side-container">
        <div class="title-text sdf-text-20-400-white">イベント一覧</div>
        <div class="side-switch-area">
          <div class="side-switch sdf-text-16-400-white">
            異常値
            <vs-switch color="#EB5757" v-model="showAbnormalValue">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
          <div class="side-switch sdf-text-16-400-white">
            正常
            <vs-switch color="#2D9CDB" v-model="showNormalValue">
              <span slot="on">ON</span>
              <span slot="off">OFF</span>
            </vs-switch>
          </div>
        </div>
      </div>
      
      <div id="main-container">
        <div class="data-report-menu-area">
          <div class="data-report-menu-item" @click="callDownloadCsv">
            <feather-icon
              icon="FileIcon"
              svgClasses="h-5 w-5"
              class="mr-2 menu-item-icon"
            /><p class="sdf-text-16-400-white">CSVダウンロード</p>
          </div>
        </div>
        <div>
          <div id="chart-column-header" class="sdf-text-14-400-mouse-gray">
            <div class="column-header-text column-date">発生日時</div>
            <div class="column-header-text column-id">ID</div>
            <div class="column-header-text column-event-name">イベント名</div>
            <div class="column-header-text column-event-value">値</div>
            <div class="column-header-text column-unit">単位</div>
            <div class="column-header-text column-event-status">ステイタス</div>
          </div>
          <engine-data-event-summary
            ref="child"
            :showNormalValue="showNormalValue"
            :showAbnormalValue="showAbnormalValue"
            :liveModeSortOrder="liveModeSortOrder"
            :dateModeSortOrder="dateModeSortOrder"
          >
          </engine-data-event-summary>
        </div>
      </div>
      
      <sdf-popup class="no-select-popup" :popupActive.sync="popupActiveNoSelect">
        <p style="margin: 30px 0px;">
          ダウンロードしたいチャンネルの左側のボックスをチェックしてください
        </p>
        <vs-button class="popup-button" :color="sdfColor.MouseGray" :style="popupButtonStyle" @click="popupActiveNoSelect = false">閉じる</vs-button>
      </sdf-popup>
    </div>
  </div>

</template>

<script>
import Vue from "vue"
import InputDisplayCondition from "../components/InputDisplayCondition";
import VesselCommunicationChannel from "../components/VesselCommunicationChannel";
import EngineDataEventSummary from "./components/EngineDataEventSummary";
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin"
import SecureDataflowService from "@/services/secureDataflowService";
import SdfPopup from "../components/SdfPopup";
import {createNamespacedHelpers} from "vuex"
import {
  StoreCommonsMixin,
  StoreMenuMixin,
  MappingTableMixin,
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";
import moment from "moment"
const { mapGetters, mapActions, mapState } = createNamespacedHelpers("monitoringVesselEngine");

// Mixin
/*
import {
  StoreCommonsMixin,
  StoreMenuMixin,
} from "@/mixins/addon/secure-dataflow";
*/

export default {
  name: "eventSummary",
  mixins: [
    StoreCommonsMixin,
    StoreMenuMixin,
    SecureDataflowMixin,
    MappingTableMixin,
    StoreMonitoringVesselManeuveringMixin
  ],
  components: {
    EngineDataEventSummary,
    InputDisplayCondition,
    SdfPopup,
    VesselCommunicationChannel
  },
  data() {
    return {
      showNormalValue: true,
      showAbnormalValue: true,
      popupActiveNoSelect: false,
      popupButtonStyle: `
        padding: 2px 36px !important;
      `,

      intervalId: null,
      timer: null,
      maneuveringLastUpdatedAt: null,
      maneuveringLastUpdateAtString: null,
      engineLastUpdatedAt: null,
      lastUpdateAt: null,

      liveModeSortOrder: "desc",
      dateModeSortOrder: "asc"
    }
  },
  computed: {
    ...mapGetters(["getSelectedCategory", "getCustomChannelIds", "getChannelTimeFrom", "getChannelTimeTo", "getVersion", "getChannelGroupData"]),
    ...mapState({
      mode: state => state.mode,
      channelGroupFocusPointMap: state => state.channelGroupFocusPointMap,
      channelMaster: state => state.channelMaster,
      liveDataTimeRange: state => state.liveDataTimeRange,
      unsubscribes: state => state.unsubscribes,
      unsubscribesForChart: state => state.unsubscribesForChart,
    }),

    operationMode() {
      if (this.channelDataManeuvering) {
        return `${this.getOperationModeLabel(
          this.channelDataManeuvering.SB44.vs
        )}`;
      }
    },
    isIdle() {
			return this.$store.state.idleVue.isIdle;
		}
  },
  watch: {
    channelDataManeuvering(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.maneuveringLastUpdatedAt = moment.unix(
          val.last_updated_at.seconds
        );
        this.updateStateTime();
      }
    },
    channelDataEngine(val) {
      if(!val) return
      if (val.last_updated_at) {
        this.engineLastUpdatedAt = moment.unix(val.last_updated_at.seconds);
        this.updateStateTime();
      }
    },
    async isIdle() {
      let r = this.$router.resolve({
        name: "login-enterprise",
        query: { logout: "force" }
      });
      window.location.assign(r.href)
    }
  },
  methods: {
    ...mapActions(["initializeCustomChannelIds", "downloadCsv", "downloadCsvByStatus"]),
    async callDownloadCsv() {
      const vessel = await SecureDataflowService.getVessel();
      let now = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + ".000Z";

      let liveDataTimeRange = this.liveDataTimeRange ? this.liveDataTimeRange : 60;
      let liveTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("HH:mm:ss");
      let liveDateTimeFrom = moment().utc().subtract(liveDataTimeRange, "minutes").format("YYYY-MM-DD") + "T" + liveTimeFrom + ".000Z";

      let time_from = this.mode === "live" ? liveDateTimeFrom : this.getChannelTimeFrom;
      let time_to = this.mode === "live" ? now : this.getChannelTimeTo;
      let sort = this.mode === "live" ? this.liveModeSortOrder : this.dateModeSortOrder

      let payload = {
        vessel_id: vessel.vessel_info.id,
        body: {
          channel_time_from: time_from,
          channel_time_to: time_to,
          status_contains: ["E"],
          status_equals: [],
          status_hides: ["E"],
          sort_order: sort
        }
      }
      
      try {
        let res = await this.downloadCsvByStatus(payload)
        const blob = new Blob([res.data], { type: "text/csv" })
        const uri = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.download = `data.csv`
        link.href = uri
        link.click()
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },

    updateStateTime() {
      // 最終更新時刻は操船データの最終更新時刻を採用
      if (this.maneuveringLastUpdatedAt) {
        this.maneuveringLastUpdateAtString = this.maneuveringLastUpdatedAt
          .local()
          .format("YYYY/MM/DD HH:mm:ss");
      } else {
        this.maneuveringLastUpdateAtString = "--/--/-- --:--:--";
      }
      
      if (this.maneuveringLastUpdatedAt && this.engineLastUpdatedAt) {
        if (this.maneuveringLastUpdatedAt.isAfter(this.engineLastUpdatedAt)) {
          this.lastUpdateAt = this.maneuveringLastUpdatedAt;
        } else {
          this.lastUpdateAt = this.engineLastUpdatedAt;
        }
        this.setWatchConnectionState();
      }
    },
    setWatchConnectionState() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (this.isDisconnect()) {
        this.setDisconnectState4gVSAT()
      } else {
        // Vue.$log.info(
        //   `[SDF] Stable 4G/VSA connection, last update at ${this.lastUpdateAt.local()}`
        // );
        this.SET_CONNECTING_STATE_4G_VSAT({
          isDisconnect: false,
          localTime: this.lastUpdateAt.local()
        });
        this.setTimerWatchConnectionState();
      }
    },
    setTimerWatchConnectionState() {
      this.timer = setTimeout(() => {
        this.setDisconnectState4gVSAT()
      }, 120000);
    },
    isDisconnect() {
      // 2分超えているかどうか
      return moment().diff(this.lastUpdateAt, "minutes") >= 2;
    },
    setDisconnectState4gVSAT() {
      Vue.$log.warn(
        `[SDF] Disconnect 4G/VSAT, last update at ${this.lastUpdateAt.local()}`
      );
      this.SET_CONNECTING_STATE_4G_VSAT({
        isDisconnect: true,
        localTime: this.lastUpdateAt.local()
      });
    }
  },
  mounted() {
    this.$store.commit("UPDATE_MAIN_LAYOUT_TYPE", "secureDataflow");
    let routerViewClass = document.getElementsByClassName("router-view");
    routerViewClass[0].style.padding = "0.0rem";
  },
  async created() {
    let vessel = await SecureDataflowService.getVessel();
    if (typeof vessel === "undefined") {
      this.SET_SHOW_DIALOG_SELECT_VESSEL(true);
    } else {
      let payload = {
        vesselInfo: vessel.vessel_info,
        maneuveringOriginId: vessel.maneuvering_origin_id,
        engineOriginId: vessel.engine_origin_id,
        alertOriginId: vessel.alert_origin_id
      };
      await this.setVesselInfoAndVersions(payload);
      await this.setChannelMaster({
        vesselId: vessel.vessel_info.id,
        params: {
          version_id: this.engineVersion.id
        }
      });
      await this.setOwnVessels()
    }
    this.getInitialFOFlow({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    })

    this.subscribeChannelDataManeuvering({
      vesselId: this.vesselInfo.id,
      versionName: this.maneuveringVersion.name
    });

    this.subscribeChannelDataEngine({
      vesselId: this.vesselInfo.id,
      versionName: this.engineVersion.name
    });

    this.subscribeChannelDataAlert({
      vesselId: this.vesselInfo.id,
      versionName: this.alertVersion.name
    });
  },
  beforeDestroy() {
    this.resetStateOfMonitoringVesselManeuvering();
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/secure-dataflow/_variables.scss";
#monitoring-vessel-engine-header {
  width: 100%;
  height: 83px;
  background: #09151C;
  display: flex;
  flex-flow: wrap;
  justify-content: space-between;
  align-items: center;
}

#header-text {
  margin-left: 120px;
}

#event-summary {
  background-color: $dark-blue-navy;
  min-height: calc(100vh);
  .vessel-communication-channel-area {
    margin-right: 40px;
  }
}

#event-data-details{
  color: $white;
  display: flex;
  #side-container {
    width: 250px;
    padding: 30px;
  }

  .menu-item-icon {
    position: absolute;
    margin-top: 3px;
  }


  .effect {
    background: $blue !important;
  }
  .vs-pagination--buttons {
    background: transparent !important;
    color: $white;
  }

  .vs-pagination--ul {
    background: $navy;
  }
  .vs-pagination--li {
    color: $white;
  }

  #main-container {
    width: 100%;
    padding-left: 30px;
  }
  .control-area {
    display: flex;
  }
  .data-report-menu-area {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 80px;
  }

  .data-report-menu-item {
    margin: 20px;
    cursor: pointer;
    p {
      font-size: 16px;
      padding-left: 29px;
    }
  }

  .side-switch {
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    width: 120px;
  }
  .side-switch-area {
    margin-top: 40px;
  }
  .side-menu-item {
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }
  .engine-data-chart-container {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  #chart-column-header {
    display: flex;
    border-bottom: solid;
    border-width: 1px;
    border-color: $gray;
  }
  .column-alerm {
    min-width: 70px;
  }
  .column-channel-id {
    min-width: 60px;
  }
  .column-channel-name {
    width: 220px;
  }
  .column-value {
    min-width: 180px;
  }
  .column-unit {
    min-width: 80px;
  }
  .column-status {
    min-width: 80px;
  }
  .column-chart {
    min-width: 220px;
  }
  .column-date {
    min-width: 220px;
  }
  .column-id {
    min-width: 120px;
  }
  .column-alert-name, .column-event-name {
    min-width: 450px;
  }
  .column-alert-value, .column-event-value {
    min-width: 120px;
  }
  .column-alert-status, .column-event-status {
    min-width: 130px;
  }
  .column-3d {
    min-width: 100px;
  }
  .pagination {
    float: right;
  }
  .item-disabled {
    cursor: default;
    color: #888888;
    p {
      color: #888888;
    }
  }
  .display-3d-popup {
    .button-3d {
      padding: 0px 13px !important;
      border-radius: 15px;
    }
    .popup-input {
      margin-top: 30px;
      margin-bottom: 30px;
      margin-right: 30px;
      width: auto;
      input {
        background: transparent;
        border-color: $white !important;
      }
      .vs-input--placeholder {
        color: $white;
      }
    }
    .popup-title {
      margin-left: 30px;
    }
    .popup-button {
      padding: 5px !important;
    }
    .sdf-popup-container {
      width: 350px;
    }
  }
}

</style>
